// Último módulo visitado (mig 122, 2026-11-03) — ver backend/utils/ultimoModulo.js.
// Solo rol usuario y Básico (semiusuario). Los demás roles conservan su módulo inicial.
export const ROLES_ULTIMO_MODULO = ['usuario', 'semiusuario'];
// Claves internas del menú. "Usuario" (perfil/contraseña) y "Broker Asignado" NO cuentan.
export const MODULOS_ULTIMO = ['Prospectación', 'Simuladores', 'Prospectos', 'Infonavit', 'Impresión', 'CRM Hipotecas', 'Actualizaciones Bancos'];

export const aplicaUltimoModulo = (rol) => ROLES_ULTIMO_MODULO.includes(rol);

export function cuentaComoUltimo(rol, modulo) {
  if (!aplicaUltimoModulo(rol) || !MODULOS_ULTIMO.includes(modulo)) return false;
  return !(rol === 'semiusuario' && modulo === 'CRM Hipotecas'); // Básico sin CRM
}

// Módulo al entrar (login o F5): pantalla segura tras "Recargar" de la pantalla de error,
// si no el último guardado si sigue disponible, si no el Simulador, si no `respaldo`.
export function menuInicial({ rol, ultimo, menus, menuSeguro, respaldo }) {
  if (menuSeguro && menus.includes('Usuario')) return 'Usuario';
  if (ultimo && cuentaComoUltimo(rol, ultimo) && menus.includes(ultimo)) return ultimo;
  if (menus.includes('Simuladores')) return 'Simuladores';
  return respaldo;
}

// Al dar clic en una pestaña: se guarda en la cuenta (BD) y en la copia local de la sesión
// (para que F5 en este dispositivo regrese aquí). Si falla, la navegación sigue igual.
export function guardarUltimoModulo(modulo) {
  try {
    const u = JSON.parse(localStorage.getItem('usuarioActual') || 'null');
    if (u) { u.ultimo_modulo = modulo; localStorage.setItem('usuarioActual', JSON.stringify(u)); }
  } catch { /* sin localStorage: solo se guarda en la cuenta */ }
  try {
    fetch('/api/mi-perfil/ultimo-modulo', {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ modulo }),
    }).catch(() => {});
  } catch { /* sin conexión: no se guarda esta vez */ }
}
